module.exports = __webpack_public_path__ + "img/catalog (22).1fe862ed.jpg";